export default {
  SAMPLE_SERVER_BASE_URL: 'https://mindhelp.mx',
  API_KEY: '46356992',
  SESSION_ID: '2_MX40NjM1Njk5Mn5-MTU4MzM2NTc4OTQyMn52WElLYzR0dGVYNjRTY3FMKzlnY1dhYTF-UH4',
  TOKEN: 'T1==cGFydG5lcl9pZD00NjM1Njk5MiZzaWc9MmI3MTEyY2IyNDQwZmNjMGI0ODNlZGY3NjQxNWNhYWZkM2ZhMmNmZjpzZXNzaW9uX2lkPTJfTVg0ME5qTTFOams1TW41LU1UVTRNek0yTlRjNE9UUXlNbjUyV0VsTFl6UjBkR1ZZTmpSVFkzRk1LemxuWTFkaFlURi1VSDQmY3JlYXRlX3RpbWU9MTU4MzM2NTc4OSZyb2xlPXB1Ymxpc2hlciZub25jZT0xNTgzMzY1Nzg5LjQyMDE3OTc0MzMxOTkmZXhwaXJlX3RpbWU9MTU4Mzk3MDU4OSZjb25uZWN0aW9uX2RhdGE9bmFtZSUzREFwcG9pbnRtZW50LTEmaW5pdGlhbF9sYXlvdXRfY2xhc3NfbGlzdD0='
};
